import conversationLabels from '../../api/conversationLabels';
import { sendExceptionToSentry } from 'shared/helpers/sentry';

const state = {};

export const getters = {};

export const actions = {
  create: async (_, label) => {
    try {
      await conversationLabels.create(label);
    } catch (error) {
      sendExceptionToSentry(error);
    }
  },
  destroy: async (_, label) => {
    try {
      await conversationLabels.destroy(label);
    } catch (error) {
      sendExceptionToSentry(error);
    }
  },
};

export const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
